enum GuestGenreType {
  active = "現役",
  breakaway = "離脱",
}
export default GuestGenreType;
